import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=79f85786&"
import script from "./Conversation.vue?vue&type=script&lang=js&"
export * from "./Conversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f85786')) {
      api.createRecord('79f85786', component.options)
    } else {
      api.reload('79f85786', component.options)
    }
    module.hot.accept("./Conversation.vue?vue&type=template&id=79f85786&", function () {
      api.rerender('79f85786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Conversation.vue"
export default component.exports